<template>
  <div class="after-pay-root" :style="cssVars()">
    <div class="after-pay-con">
      <div v-if="appType === 'client'">
        <img v-if="pkgName" :src="getMatchImg('app-logo', pkgName)" />
      </div>
      <div v-if="appType === 'web'">
        <img v-if="webPkgName === 'vava'" src="@/assets/packageAssets/packagesWeb/vavaWeb/app-logo.png" />
      </div>
      <MyPLabel class="page-tips" :str="$t('lang.PayThirdBack.k001')" :numsOption="[{ value: pkgName || webPkgName }]" />

      <button @click="handleJump">
        <img src="@/assets/packageAssets/common/arrow10.png" />
      </button>
      <p class="btn-tips">{{ $t('lang.PayThirdBack.k002') }}</p>
    </div>
  </div>
</template>

<script>
import { getPackageNamePayBack } from '@/api/imee'
import { getQueryParams } from '@/utils/common.js'
import { pageCssVars } from './z-style-cfg.js'

import BaseConfig from '@/config/base.js'

export default {
  mixins: [pageCssVars],
  data() {
    return {
      originPkgName: '',
      appType: 'client',
      pkgName: '',
      webPkgName: '',
    }
  },
  methods: {
    handleJump() {
      if (this.appType === 'web') {
        window.close()
        return
      }

      this.handleToApp()
    },
    handleToApp() {
      if (BaseConfig.apps[this.pkgName]?.schema || BaseConfig.apps.default.schema) {
        const jumpUrl = `${BaseConfig.apps[this.pkgName]?.schema || BaseConfig.apps.default.schema}${this.originPkgName}`
        window.location.href = jumpUrl
      }
    },
  },
  created() {
    if (this.$route.query.packageName) {
      this.originPkgName = this.$route.query.packageName

      if (BaseConfig.apps.vavaWeb?.packages.includes(this.originPkgName)) {
        this.appType = 'web'
        this.webPkgName = 'vava'
        window.close()
        return
      }

      this.appType = 'client'
      this.pkgName = BaseConfig.packageNameMap[this.$route.query.packageName]
      this.handleToApp()
    }
    // url中无包信息
    else {
      try {
        const queryObj = getQueryParams(window.location.href)
        if (queryObj && Object.keys(queryObj).length) {
          getPackageNamePayBack(queryObj).then((resData) => {
            if (resData && resData.appPackageName && BaseConfig.apps.vavaWeb?.packages.includes(resData.appPackageName)) {
              this.originPkgName = resData.appPackageName
              this.appType = 'web'
              this.webPkgName = 'vava'
              window.close()
              return
            }

            if (resData && resData.appPackageName && BaseConfig.packageNameMap[resData.appPackageName]) {
              this.originPkgName = resData.appPackageName
              this.appType = 'client'
              this.pkgName = BaseConfig.packageNameMap[resData.appPackageName]
              this.handleToApp()
            }
          })
        }
      } catch (err) {
        console.log('try catch err:', err)
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.after-pay-root {
  width: 100vw;
  min-height: 100vh;
  .after-pay-con {
    padding: 0 20px 100px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    div {
      width: 80px;
      height: 80px;
      margin-top: 30vh;
      font-size: 0;
      background-color: #eaeaea;
      border-radius: 16px;
      img {
        width: 100%;
      }
    }
    .page-tips {
      text-align: center;
      font-family: var(--string-font);
      font-size: var(--fs-16);
      font-weight: var(--fw-400);
      line-height: var(--lh-title-20);
      font-style: normal;
      color: var(--Fonts-Font-1, #333);
      margin-top: 24px;
    }

    button {
      width: 255px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 100px;
      font-family: var(--string-font);
      font-size: var(--fs-40);
      font-weight: var(--fw-700);
      line-height: var(--lh-display-48);
      border-radius: 56px;
      background: var(--button-color, #eaeaea);
      color: #ffffff;

      img {
        width: 24px;
        height: 24px;
      }
    }

    .btn-tips {
      text-align: center;
      font-family: var(--string-font);
      font-size: var(--fs-16);
      font-weight: var(--fw-400);
      line-height: var(--lh-label-18);
      font-style: normal;
      color: var(--Fonts-Font-3, #b2b2b2);

      margin-top: 12px;
    }
  }
}
</style>
